//13-aug-2018 Priyan R
import React from 'react';
import sharedglobals from '../sharedglobals'
import PropTypes from 'prop-types';
import { ManualUploadFile } from '../infrastructure/httphelper';
import * as appActions from '../actions/appactions';
import { useController, useForm } from "react-hook-form";

export function FileUpload(props) {
    let isUploading=false;
    let errorMessage='';
    const fileInput = document.getElementById(props.id);
    const propsName = props.name;
    const fileType= props.fileType;
    const subFolder= props.subFolder;
    // Create a new File object
    /*const myFile = new File('myFile.txt');

    // Now let's create a DataTransfer to get a FileList
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(myFile);
    fileInput.files = dataTransfer.files;*/

    const handleChange = async(e) => {
        if (!e.target || e.target.files.length == 0)
            return;
        let file = e.target.files[0];
        try{
            let docId=await ManualUploadFile(file,fileType,subFolder);
            let result={
                id: props.id,
                file: file,
                fileName:file.name,  
                fileType: file.type,              
                docIdEncrypted: docId
            };
            props.onChange(result);
        }catch(e){
            appActions.handleError(e);
        }        

    }
    const handleClick = async(e) => {
        e.target.value = null
        let result={
            id: props.id,
            file: null,
            fileName:null,  
            fileType: null,              
            docIdEncrypted: null
        };
        props.onChange(result);
    };
    let FileInput = <input id={props.id}
        name={props.name}
        type='file'
        accept={props.accept}
        file={props.file}
        disabled={props.disabled}
        className={props.className}
        onChange={e => handleChange(e)}
        onClick={e => handleClick(e)}
        hidden={props.hidden}
    />
    return (
        <div>

            {FileInput}
            {/*props.value &&
                <div>{<label className="badge bg-light text-dark">{props.file}</label>}</div>*/

            }
            {
                isUploading &&
                <i className="spinner-border avatar-md text-primary" ></i>
            }
            {
                errorMessage &&
                <div>{errorMessage}</div>
            }
        </div>
    )
    
}
